import React, { ReactNode } from 'react';
import { EpAvatar } from '../EpAvatar';
import { EpButton } from '../EpButton';
import './EpContentSpace.scss';

interface IEpContentSpaceTranslations {
  title: string;
  buttonText?: string;
}

interface IEpContentSpaceProps {
  contentSpaceType?: 'empty' | 'danger';
  contentSpaceAvatarId: string;
  contentSpaceAvatarIconName?: string;
  contentSpaceButtonId: string;
  contentSpaceButtonOnClickFunc: () => void;
  translations: IEpContentSpaceTranslations;
  customClasses?: string;
  children?: ReactNode;
}

export const EpContentSpace: React.FC<IEpContentSpaceProps> = ({
  contentSpaceType = 'empty',
  contentSpaceAvatarId,
  contentSpaceAvatarIconName = contentSpaceType === 'danger'
    ? 'SolidTrashAlt'
    : 'SolidFolderOpen',
  contentSpaceButtonId,
  contentSpaceButtonOnClickFunc,
  translations,
  customClasses = '',
  children,
}) => {
  const parsedTranslations: IEpContentSpaceTranslations = translations;

  return (
    <div
      className={`ep-content-space ep-content-space--${contentSpaceType} ${customClasses}`}
    >
      <EpAvatar
        avatarId={contentSpaceAvatarId}
        avatarContent="icon"
        avatarSize="2xl"
        avatarIconName={contentSpaceAvatarIconName}
        {...(contentSpaceType === 'danger' && { avatarBgColor: 'RedLight35' })}
        {...(contentSpaceType === 'danger' && { avatarColor: 'RedLight20' })}
      />

      <div className="ep-content-space__wrapper">
        <h4 className="ep-content-space__title">{parsedTranslations?.title}</h4>
        {children}
      </div>

      {parsedTranslations?.buttonText && (
        <EpButton
          buttonId={contentSpaceButtonId}
          buttonSize="lg"
          buttonType="primary-outline"
          buttonLeftIconName="SolidCheck"
          buttonOnClickFunc={contentSpaceButtonOnClickFunc}
          buttonText={parsedTranslations?.buttonText}
          customClasses="ep-content-space__button"
        ></EpButton>
      )}
    </div>
  );
};
